import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

function HelpCenter() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow bg-gray-50 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Help Center</h1>
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-lg text-gray-700 mb-6">
              Need assistance? We're here to help!
            </p>
            <div className="space-y-6">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Getting Started</h2>
                <p className="text-gray-600">
                  Learn how to create an account, search for clubs, and join your first board game community.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Common Questions</h2>
                <p className="text-gray-600">
                  Find answers to frequently asked questions about using BoardVoyage.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Contact Support</h2>
                <p className="text-gray-600">
                  Can't find what you're looking for? Reach out to our support team for personalized assistance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HelpCenter;
